import { render, staticRenderFns } from "./ModuleEdit.vue?vue&type=template&id=5dd135e8&lang=html&"
import script from "./ModuleEdit.vue?vue&type=script&lang=js&"
export * from "./ModuleEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModuleEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports